import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import Breadcrumb from "sushiweb/Breadcrumb";
import Back from "sushiweb/Icons/all/Back";
import SlotDetailsList from "../../components/SlotDetails/SlotDetailsList";
import { FlexContainer } from "../../constants/assets/containers";
import variables from "../../constants/assets/variables";
import { getActiveSlot } from "../../store/actions/Slots";
import { isMobile } from "../../utils";
import { connect } from "react-redux";

const SlotDetails = ({ availableSlotDetails = {}, getActiveSlot }) => {
  const { id } = useParams();
  const history = useHistory();

  const handleBackClick = () => {
    history.push("/slots-details");
  };

  useEffect(() => {
    const payload = {
      slot_capacity_id: Number(id),
    };
    getActiveSlot(payload);
  }, [id]);

  return (
    <SlotDetailsContainer>
      <TopContainer justify="flex-start">
        <Back
          onClick={handleBackClick}
          className="mr-10 backBtn"
          color={variables.grey400}
        />
        <Breadcrumb className="sushi-breadcrumbs">
          <Breadcrumb.Link onClick={handleBackClick}>
            Available Slots
          </Breadcrumb.Link>
          {Object.keys(availableSlotDetails).length > 0 && (
            <Breadcrumb.Link>{availableSlotDetails.slot_name}</Breadcrumb.Link>
          )}
        </Breadcrumb>
      </TopContainer>
      <SlotDetailsList data={availableSlotDetails} />
    </SlotDetailsContainer>
  );
};

const SlotDetailsContainer = styled.section``;

const TopContainer = styled(FlexContainer)`
  padding-top: 20px;
  flex: 0 1 30%;
  margin-bottom: ${isMobile() ? "20px" : "unset"};
  & > div {
    flex-direction: ${isMobile() ? "row" : "column"};
  }
`;

function mapStateToProps(state) {
  const { Slots } = state;
  return {
    availableSlotDetails: Slots.activeSlot,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getActiveSlot: bindActionCreators(getActiveSlot, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SlotDetails);
